import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";
import WebServiceContext from "../../webService/WebServiceContext";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, scales, } from 'chart.js';
import { Bar } from 'react-chartjs-2';

import { Loading } from "../SVG";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    scales
);


const money = (value: number) => {
    var formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
    });
    return formatter.format(value)
}

type YearBonusChatProps = {
    currentYear:number
}

const YearBonusChat = (props:YearBonusChatProps) => {
    const ws = useContext(WebServiceContext)

    const [value1, setValue1] = useState<number>(0)
    const [value3, setValue3] = useState<number>(0)
    const [value6, setValue6] = useState<number>(0)
    const [value9, setValue9] = useState<number>(0)
    const [resValue, setResValue] = useState<number>(0)
    const [bonusValue, setBonusValue] = useState<number[]>([0,0,0,0])
    const [isLoading, setIsLoading] = useState<boolean>(true)


    useEffect(() => {
        setIsLoading(true)
        ws.webservice.asyncPerformance("44005_年終獎金總表", props.currentYear).then((res: any) => {
            setIsLoading(false)

            let endValue = 0;
            let bonus:number[] = [0,0,0,0];

            if (res.length > 0) {
                endValue = res[0]['年終業績'];
                setResValue(parseInt(res[0]['年終業績']))
                
                //1%
                if (endValue < 500000) {
                    setValue1(endValue)
                    bonus[0] = Math.floor(endValue * 0.01);
                    setBonusValue(bonus)
                    return;
                } else {
                    setValue1(500000)
                    bonus[0] = Math.floor(500000 * 0.01);
                }

                //3%
                if (endValue < 1000000) {
                    setValue1(0)
                    setValue3(endValue )
                    bonus[1] = Math.floor( (endValue) * 0.03);
                    bonus[0] = 0;
                    setBonusValue(bonus)
                    return;
                } else {
                    setValue1(0)
                    setValue3(1000000)
                    bonus[1] = Math.floor(1000000 * 0.03);
                    bonus[0] = 0;
                }
                
                //6%
                if (endValue <= 2000000) {                        
                    setValue6(endValue - 1000000)
                    bonus[2] = Math.floor((endValue - 1000000) * 0.06);
                    setBonusValue(bonus)
                    return;
                } else {             
                    setValue6(1000000)
                    bonus[0] = 0;
                    bonus[2] = Math.floor( 1000000 * 0.06 );
                }

                //9%
                if (endValue > 2000000) {
                    setValue9(endValue - 2000000)
                    bonus[3] = Math.floor((endValue - 2000000) * 0.09);
                    setBonusValue(bonus)
                }
                
                
            }
        })
        return
    },[props.currentYear])

    if (isLoading) {
        return (<Loading/>)
    } else {
        return (
            <>
            <div className="card-short">
                <span className="value">
                    {money(bonusValue.reduce((a:number,b:number)=>a+b))}
                </span>
            </div>
            <div className="card-content">
                <div className="card-mesg">
                    <span className="value">
                        {props.currentYear}
                    </span>    
                    年 業績：
                    <span className="value">
                        {money(resValue)}
                    </span>
                    年終獎金：
                    <span className="value">
                        {money(bonusValue.reduce((a:number,b:number)=>a+b))}
                    </span>
                </div>
                <Bar
                    height={60}
                    data={{
                        labels: [""],
                        datasets: [
                            {
                                data: [value1],
                                label:"1%",
                                backgroundColor:'rgba(106, 51, 163, 0.6)',
                                borderColor: 'rgba(106, 51, 163, 1)',                                          
                                borderWidth: 1
                            },
                            {
                                data: [value3],
                                label: '3%',
                                backgroundColor:'rgba(118, 153, 43, 0.6)',
                                borderColor: 'rgba(118, 153, 43, 1)',                                          
                                borderWidth: 1
                            },
                            {
                                data: [value6],
                                label: '6%',
                                backgroundColor:'rgba(47, 126, 148, 0.6)',
                                borderColor: 'rgba(47, 126, 148, 1)',                                          
                                borderWidth: 1
                            },
                            {
                                data: [value9],
                                backgroundColor:'rgba(191, 111, 27, 0.6)',
                                borderColor: 'rgba(191, 111, 27, 1)',                                          
                                borderWidth: 1
                            },
                        ]
                    }}
                    options={{
                        indexAxis: 'y' as const,
                        scales: {
                            x: {
                                stacked: true,
                                min: 0,
                                //max: 200,
                                ticks: {
                                    callback: (value):string => {
                                        const _v:number = value as number;
                                        if (_v < 10000) {
                                            return money(_v);
                                        } else {
                                            return (_v / 10000) + "萬";
                                        }
                                    }
                                }
                            },
                            y:{
                                stacked: true,
                            }
                        },
                        elements: {
                            bar: {
                                borderWidth: 2,
                            },
                        },
                        responsive: true,
                        plugins: {
                            legend: {
                                display: false
                            },
                            tooltip: { 
                                enabled: false
                            }
                        }
                    }}
                />
                <table id="Year_table" className="dashboard-table">
                    <thead>
                        <tr>
                            <th className="p1">1%</th>
                            <th className="p3">3%</th>
                            <th className="p6">6%</th>
                            <th className="p9">9%</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="p1">{money(bonusValue[0])}</td>
                            <td className="p3">{money(bonusValue[1])}</td>
                            <td className="p6">{money(bonusValue[2])}</td>
                            <td className="p9">{money(bonusValue[3])}</td>
                        </tr>
                        {/**
                         * 
                        <tr>
                            <td colSpan={4}>
                                {money(resValue)}
                            </td>
                        </tr>
                        */}
                        
                    </tbody>
                </table>
            </div>
            </>
        )
    }
};

export default YearBonusChat